// NEW_FILE_JUSTIFIED: Benefit description panel with optional exclusion notice — reusable across all benefit items
import { Info, TriangleAlert } from 'lucide-react';
import type { IBenefitInfoPanelProps } from '@/@types/coverage';

export function BenefitInfoPanel({ description, exclusionText }: IBenefitInfoPanelProps) {
  return (
    <div className="border border-border rounded-md">
      <div className="px-5 pt-3 pb-4 flex flex-col gap-2">
        <div className="flex items-center gap-1.5">
          <Info aria-hidden="true" className="h-3.5 w-3.5 text-foreground-muted shrink-0" />
          <span className="text-sm font-semibold text-muted-foreground">Benefit Description</span>
        </div>
        {description && (
          <p className="text-sm text-muted-foreground leading-relaxed">{description}</p>
        )}

        {exclusionText && (
          <div className="flex items-start gap-1.5 rounded-md bg-red-950/30 light:bg-red-50 px-2.5 py-2">
            <TriangleAlert
              aria-hidden="true"
              className="h-3.5 w-3.5 text-destructive shrink-0 mt-0.5"
            />
            <p className="text-xs text-destructive leading-snug">{exclusionText}</p>
          </div>
        )}
      </div>
    </div>
  );
}
